import { useEffect, useState } from 'react';
import theme from 'config/theme';
import Spacing from 'components/Spacing';
import { Eyebrow } from 'components/Typography';
import { IssueCard } from 'components/Cards/IssueCard';
import { useAppDispatch, useAppSelector } from 'helpers/hooks';
import { getSetsStateAndData } from 'selectors/sets';
import { getSets } from 'store/sets/actions';
import { ITrendingIssue } from 'store/sets/types';
import { defaultTrendingIssues } from './constants';
import { SET_QUERY_STRINGS } from 'constants/dbRecords';
import {
  TrendingIssuesGrid,
  TrendingIssuesContainer,
  IssueContainer,
  HiddenContainer,
  PairColumn,
} from './styled';

const showMaxImpactOnly = false;

export const TrendingSection = () => {
  const dispatch = useAppDispatch();
  const { setsState, setsData } = useAppSelector(getSetsStateAndData);
  const [trendingIssues, setTrendingIssues] = useState<ITrendingIssue[]>();
  const [trendingIssuesByPairs, setTrendingIssuesByPairs] = useState<ITrendingIssue[][]>();

  useEffect(() => {
    dispatch(getSets(SET_QUERY_STRINGS.TOP_ISSUES));
  }, []);

  useEffect(() => {
    if (setsData && setsData.querystring === SET_QUERY_STRINGS.TOP_ISSUES && !setsState.isLoading) {
      const setTags = setsData?.set_pages;
      const pairs: ITrendingIssue[][] = [];
      const issues = Array<ITrendingIssue>();
      if (setTags?.length) {
        for (let i = 0; i < setTags.length && i < 5; i++) {
          issues.push({
            id: setTags[i].page_id,
            name: setsData.pages.find(page => page.id === setTags[i].page_id)?.value || '',
            redirect_url: `donate?p=${
              setsData.pages.find(page => page.id === setTags[i].page_id)?.query_str
            }`,
            raised: setTags[i].page_fundraising_raised,
            fundraising_goal: setTags[i].page_fundraising_goal,
            cta: 'Support Now',
          });
        }
        const learnMoreIssue: ITrendingIssue = {
          id: -1,
          name: 'Learn more about other issues that need your support.',
          redirect_url: `set?p=${SET_QUERY_STRINGS.TOP_ISSUES}`,
          raised: '',
          fundraising_goal: '',
          cta: 'Explore Now',
        };
        issues.push(learnMoreIssue);

        const numPairs = Math.ceil(issues.length / 2);
        for (let i = 0; i < numPairs; i++) {
          const pair = issues.slice(i * 2, i * 2 + 2);
          if (pair.length === 1) {
            pair.push(learnMoreIssue);
          }
          pairs.push(pair);
        }
        setTrendingIssuesByPairs(pairs);
        setTrendingIssues(issues);
      }
    }
  }, [setsState]);

  if (showMaxImpactOnly || setsState.error || !trendingIssues?.length) {
    return (
      <TrendingIssuesContainer>
        <Eyebrow style={{ paddingLeft: 20 }}>High priority donations</Eyebrow>
        <TrendingIssuesGrid style={{ paddingLeft: 20, paddingRight: 20 }}>
          {defaultTrendingIssues.map(issue => (
            <IssueCard key={issue.id} issue={issue} />
          ))}
        </TrendingIssuesGrid>
      </TrendingIssuesContainer>
    );
  }
  return (
    <TrendingIssuesContainer>
      <Eyebrow $color={theme.colors.inkBlue} style={{ paddingLeft: 20 }}>
        Trending issues
      </Eyebrow>
      <TrendingIssuesGrid>
        <HiddenContainer $showInDesktop={true}>
          {trendingIssues?.map((issue, i) => (
            <IssueContainer $isOdd={i % 2 !== 0} key={i}>
              <IssueCard key={issue.id} issue={issue} />
            </IssueContainer>
          ))}
        </HiddenContainer>
        <HiddenContainer $showInDesktop={false}>
          {trendingIssuesByPairs?.map((pair, index) => (
            <PairColumn
              $position={index}
              $isLast={index === (trendingIssuesByPairs?.length ?? 1) - 1}
              key={index}
            >
              {pair?.map(issue => (
                <div key={issue.id}>
                  <IssueCard issue={issue} />
                  <Spacing $size={30} />
                </div>
              ))}
            </PairColumn>
          ))}
        </HiddenContainer>
      </TrendingIssuesGrid>
    </TrendingIssuesContainer>
  );
};
